var SpriteSymbol = require("../../../../../nike-mobile/node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../nike-mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "live-analyse-sl",
  "use": "live-analyse-sl-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"live-analyse-sl\"><path d=\"M7 0a7 7 0 110 14A7 7 0 017 0zm0 1.5a5.5 5.5 0 100 11 5.5 5.5 0 100-11zm.198 2a.65.65 0 01.61.425L9.97 9.792a.527.527 0 01-.494.708h-.285a.65.65 0 01-.617-.445l-.33-.997h-2.49l-.327.995a.65.65 0 01-.618.447h-.284a.527.527 0 01-.495-.709l2.15-5.865a.648.648 0 01.61-.426zm-.205 1.77l-.856 2.62H7.86l-.867-2.62z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id